import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

export interface PositionMapping {
  fromId: string;
  toId: string;
}

export class TransferComponentForm extends FormGroup {
  readonly tenantId = this.get('tenantId') as FormControl<string>;
  readonly componentId = this.get('componentId') as FormControl<string>;
  readonly targetDepartmentId = this.get('targetDepartmentId') as FormControl<string>;
  readonly parentComponentId = this.get('parentComponentId') as FormControl<string | null>;
  readonly responsiblePositionsMap = this.get('responsiblePositionsMap') as FormGroup;
  readonly accessPositionsMap = this.get('accessPositionsMap') as FormGroup;

  constructor(readonly fb: FormBuilder = new FormBuilder()) {
    super(
      fb.group({
        tenantId: ['', Validators.required],
        componentId: ['', Validators.required],
        targetDepartmentId: ['', Validators.required],
        parentComponentId: [null],
        responsiblePositionsMap: fb.group({}),
        accessPositionsMap: fb.group({}),
      }).controls
    );
  }

  createRoleMappingGroup(): FormGroup {
    return this.fb.group({
      position: [[]],
      positionGroup: [[]],
    });
  }
}
